import { render } from "./ChapterMid.vue?vue&type=template&id=27180642"
import script from "./ChapterMid.vue?vue&type=script&lang=js"
export * from "./ChapterMid.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__